import { useCreateOrder } from "@/features/orders";

/** Places a guest custom order and remembers it on this device. */
export function useCreateCustomOrder(options = {}) {
  return useCreateOrder({ ...options, custom: true });
}
